"use client";
import { styled } from "@mui/material/styles";
import * as React from "react";

const PageHeaderToolbarRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(1),
  // Ensure the toolbar is always on the right side, even after wrapping
  marginLeft: "auto",
}));

export interface PageHeaderToolbarProps {
  children?: React.ReactNode;
}

function PageHeaderToolbar(props: PageHeaderToolbarProps) {
  return <PageHeaderToolbarRoot {...props} />;
}

export default PageHeaderToolbar;
